

























export default {
  name: "PasienCustomWarningIndicator",
  props: {
    active: {
      type: Boolean,
      default: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "25"
    },
    color: {
      type: String,
      default: "gray"
    },
    icon: {
      type: String,
      default: "mdi-alert-octagram"
    },
    activeText: {
      type: String,
      default: null
    },
    inactiveText: {
      type: String,
      default: null
    },
    actionable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // toggleProgress: false
    };
  },
  methods: {
    toggleActive() {
      this.$emit("toggleActive");
    }
  },
  computed: {
    text() {
      return this.active ? this.activeText : this.inactiveText;
    }
  }
};
